import { Action, Dispatch } from 'redux'
import { db } from 'firebase/index'
import { State } from 'index'
import { StockType } from 'types/stock'
import { ScheduleType } from 'types/schedule'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { sendNewStoreMessage } from 'reducks/messages/operations'
import { publishFirstStock } from 'repos/store'
import { updatePublishFirstStockAction } from 'reducks/store/actions'
import { BreadType } from 'types/bread'
import { addNotifiedTypes } from 'reducks/bread/operations'
import { addStoreStockMessageQueue } from 'reducks/storeStockMessageQueue/operations'

const createStocks = ({
  bread,
  date,
  defaultStock,
  isOrderable,
  schedule,
  stocks,
}: {
  bread: BreadType
  date: string
  defaultStock?: StockType
  isOrderable: boolean
  schedule: ScheduleType
  stocks: StockType[]
}) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    dispatch(showLoadingAction())
    const storeRef = getState().auth.store_ref
    const storeStatus = getState().store.status
    const isBeforePublishingStock = getState().store.is_before_publishing_stock
    const batch = db.batch()

    for (let i = 0; i < stocks.length; i = (i + 1) | 0) {
      const stock = stocks[i]
      // オーダー可能時間でなければ通知しない（オーダー開始時の通知に任せる）
      if (!isOrderable) {
        stock.last_notified_time = null
      }
      const ref = storeRef
        .collection('store_stocks')
        .doc(`stock_daily_${schedule.schedule_ref?.id}-${date}_${stock.pickupable_time}`)
      if (!ref) continue
      delete stock.stock_ref
      // sacri stationの場合、販売元店舗のrefを追加する
      if (typeof schedule.manufacturer_ref !== 'undefined') {
        stock.manufacturer_ref = schedule.manufacturer_ref
      }
      batch.set(ref, stock)
    }

    // デフォルトの受渡解禁時刻が存在しなければis_deletedフラグをつけて作成する
    for (let i = 0; i < schedule.default_stocks.length; i = (i + 1) | 0) {
      if (!defaultStock) continue
      const scheduleDefaultStock = schedule.default_stocks[i]
      if (stocks.some((stock) => stock.pickupable_time === scheduleDefaultStock.pickupable_time)) continue
      const ref = storeRef
        .collection('store_stocks')
        .doc(`stock_daily_${schedule.schedule_ref?.id}-${date}_${scheduleDefaultStock.pickupable_time}`)
      if (!ref) continue
      defaultStock.last_notified_time = null
      defaultStock.is_deleted = true
      defaultStock.pickupable_time = scheduleDefaultStock.pickupable_time
      delete defaultStock.stock_ref
      // sacri stationの場合、販売元店舗のrefを追加する
      if (typeof schedule.manufacturer_ref !== 'undefined') {
        defaultStock.manufacturer_ref = schedule.manufacturer_ref
      }
      batch.set(ref, defaultStock)
    }
    // 店舗が初めて在庫を公開する場合、5km圏内のユーザーにPush通知を送る
    if (isBeforePublishingStock && storeStatus === 'public') {
      await publishFirstStock(storeRef)
      dispatch(updatePublishFirstStockAction())
      await sendNewStoreMessage(storeRef)
    } else {
      const type = 'daily'
      // この商品で初めて在庫を設定する場合、ユーザーに通知を送る
      if (!bread.notified_types?.includes(type)) {
        await Promise.all([
          addNotifiedTypes({ bread, type }),
          addStoreStockMessageQueue({ breadRef: stocks[0].bread_ref, storeRef }),
        ])
      }
    }
    return batch
      .commit()
      .then(() => {
        dispatch(hideLoadingAction())
      })
      .catch((error) => {
        console.error(error)
        dispatch(hideLoadingAction())
      })
  }
}

export default createStocks
